import _ from "lodash";
import { createContext, useEffect, useMemo, useState } from "react";

export const ZipCodesContext = createContext();

function unique(arr, keyProps) {
  return _.uniqBy(arr, (e) => JSON.stringify(_.pick(e, keyProps)));
}

const dynamicSort = (property) => {
  let sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */
    const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  };
};

const capitalizeFirstLetter = (str) => {
  if (str && typeof str === 'string' && str.length > 0) {
    return str.trim().charAt(0).toUpperCase() + str.slice(1);
  }
  return '';
};

const ZipCodesContextProvider = ({ children }) => {
  const [zipCodes, setZipCodes] = useState([]);
  const zipCodeOptions = useMemo(() => (
    zipCodes.map((e) => ({
      label: e.zip, value: e.zip, state: e.state, city: e.city, county: e.county,
    }))
      .sort(dynamicSort('label'))
  ), [zipCodes]);

  const countyOptions = useMemo(() => (
    unique(zipCodes, ['state', 'county'])
      .map((e) => ({
        label: `${capitalizeFirstLetter(e.county)} (${e.state})`,
        value: `${capitalizeFirstLetter(e.county)} (${e.state})`,
        state: e.state
      }))
      .sort(dynamicSort('label'))
  ), [zipCodes]);

  const cityOptions = useMemo(() => (
    unique(zipCodes, ['state', 'city'])
      .map((e) => ({
        label: `${capitalizeFirstLetter(e.city)} (${e.state})`,
        value: `${capitalizeFirstLetter(e.city)} (${e.state})`,
        state: e.state,
      }))
      .sort(dynamicSort('label'))
  ), [zipCodes]);

  const areaCodeOptions = useMemo(() => (
    unique(zipCodes, ['areacode']).map((e) => ({
      label: `${e.areacode} (${e.state})`,
      value: `${e.areacode} (${e.state})`,
      state: e.state,
      city: e.city,
      county: e.county,
    }))
  ), [zipCodes]);

  useEffect(() => {
    import('common/data/zip_codes.json').then(data => {
      setZipCodes(data.default)
    })
  }, []);

  return (
    <ZipCodesContext.Provider value={{ zipCodes, countyOptions, zipCodeOptions, cityOptions, areaCodeOptions }}>
    {children}
    </ZipCodesContext.Provider>
  );
}

export default ZipCodesContextProvider;